// Predicados usados pelas validacoes dos formularios. Sao predicados, e nao
// geradores de mensagem, porque o texto varia com o genero da palavra em
// portugues ("Nome é obrigatório" x "Senha é obrigatória").

export const SENHA_MINIMA = 6;

export const vazio = (valor: string) => !valor.trim();

export const cpfIncompleto = (valor: string) => valor.replace(/\D/g, '').length !== 11;

export const emailInvalido = (valor: string) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor.trim());
